import { BotMessageSquare } from "lucide-react"

interface Props {
  size?: number
  className?: string
}

const BotAvatar = ({ size = 20, className = "" }: Props) => (
  <span
    className={`inline-flex h-10 w-10 min-w-10 items-center justify-center rounded-full bg-purple-400 ${className}`}
  >
    <span className="leading-none text-white">
      <BotMessageSquare size={size} aria-hidden="true" />
    </span>
  </span>
)

export default BotAvatar
